export default __webpack_public_path__ + "static/media/pin-target.12f82262.svg";